export default function Portfolio() {
  const projects = [
    {
      category: 'Tall Buildings',
      title: 'High-Rise Commercial Towers',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20upward%20angle%20view%20of%20modern%20glass%20skyscraper%20under%20construction%20with%20massive%20tower%20crane%20against%20blue%20sky%2C%20steel%20framework%20and%20concrete%20core%20visible%2C%20professional%20construction%20photography%20showing%20scale%20and%20height%20of%20mega%20tall%20building%20project%2C%20clean%20minimalist%20background%20emphasizing%20vertical%20architecture&width=800&height=900&seq=port-tall-001&orientation=portrait',
      size: 'large'
    },
    {
      category: 'Major Airports',
      title: 'International Terminal Expansion',
      image: 'https://readdy.ai/api/search-image?query=Realistic%20wide%20angle%20interior%20photograph%20of%20a%20massive%20international%20airport%20terminal%20under%20construction%2C%20exposed%20steel%20roof%20trusses%20and%20structural%20beams%2C%20concrete%20floors%20with%20construction%20workers%20and%20heavy%20equipment%20visible%2C%20natural%20daylight%20streaming%20through%20large%20glass%20curtain%20wall%20panels%2C%20photorealistic%20construction%20site%20documentation%20photography%2C%20dust%20and%20activity%20showing%20active%20mega%20project%20progress&width=700&height=900&seq=port-air-002&orientation=portrait',
      size: 'medium'
    },
    {
      category: 'Roads & Bridges',
      title: 'Highway Interchange Systems',
      image: 'https://readdy.ai/api/search-image?query=Sweeping%20aerial%20view%20of%20complex%20multi-level%20highway%20interchange%20at%20dusk%20with%20elegant%20curved%20bridges%20and%20ramps%2C%20modern%20infrastructure%20engineering%20with%20smooth%20concrete%20surfaces%2C%20dramatic%20lighting%20showing%20scale%20of%20transportation%20project%2C%20clean%20minimalist%20composition%20emphasizing%20geometric%20design&width=600&height=400&seq=port-road-001&orientation=landscape',
      size: 'small'
    },
    {
      category: 'Mixed-Use Commercial',
      title: 'Urban Development Complex',
      image: 'https://readdy.ai/api/search-image?query=Modern%20mixed-use%20development%20with%20residential%20towers%20and%20retail%20podium%2C%20contemporary%20architecture%20with%20glass%20and%20steel%20facades%2C%20urban%20plaza%20with%20landscaping%2C%20professional%20architectural%20rendering%20showing%20integrated%20commercial%20and%20residential%20spaces%2C%20clean%20bright%20atmosphere%20with%20organized%20layout&width=600&height=400&seq=port-mix-001&orientation=landscape',
      size: 'small'
    },
    {
      category: 'Large Subdivisions',
      title: 'Master-Planned Communities',
      image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20large%20master-planned%20residential%20subdivision%20with%20organized%20street%20grid%20and%20housing%20development%2C%20community%20infrastructure%20with%20parks%20and%20amenities%20visible%2C%20professional%20site%20planning%20photography%20showing%20scale%20of%20residential%20project%2C%20clean%20organized%20layout%20with%20natural%20landscaping&width=600&height=400&seq=port-sub-001&orientation=landscape',
      size: 'small'
    },
    {
      category: 'Large Data Centers',
      title: 'Hyperscale Data Facilities',
      image: 'https://readdy.ai/api/search-image?query=Interior%20of%20massive%20data%20center%20under%20construction%20with%20rows%20of%20server%20racks%20and%20cable%20management%20systems%2C%20high-tech%20industrial%20environment%20with%20organized%20infrastructure%2C%20professional%20construction%20photography%20showing%20scale%20and%20precision%20of%20technology%20facility%2C%20clean%20minimalist%20background%20with%20blue%20accent%20lighting&width=700&height=600&seq=port-data-001&orientation=landscape',
      size: 'medium'
    },
    {
      category: 'Electric Substations',
      title: 'High-Voltage Infrastructure',
      image: 'https://readdy.ai/api/search-image?query=Modern%20electric%20substation%20with%20high-voltage%20transformers%20and%20transmission%20towers%2C%20organized%20industrial%20infrastructure%20with%20geometric%20patterns%2C%20professional%20engineering%20photography%20showing%20scale%20of%20electrical%20power%20facility%2C%20clean%20industrial%20environment%20with%20blue%20sky%20background&width=800&height=600&seq=port-elec-001&orientation=landscape',
      size: 'large'
    },
    {
      category: 'Industrial & Energy',
      title: 'Power Generation Facilities',
      image: 'https://readdy.ai/api/search-image?query=Large%20industrial%20power%20plant%20or%20energy%20facility%20with%20massive%20steel%20structures%20and%20processing%20equipment%2C%20modern%20industrial%20architecture%20with%20organized%20piping%20systems%2C%20professional%20construction%20photography%20showing%20scale%20of%20energy%20infrastructure%20project%2C%20clean%20industrial%20environment%20with%20dramatic%20lighting&width=600&height=500&seq=port-ind-001&orientation=landscape',
      size: 'small'
    },
    {
      category: 'Underground Utilities',
      title: 'Tunnel & Pipeline Systems',
      image: 'https://readdy.ai/api/search-image?query=Underground%20tunnel%20construction%20with%20massive%20tunnel%20boring%20machine%20and%20concrete%20lined%20passage%2C%20modern%20infrastructure%20engineering%20with%20organized%20utility%20systems%2C%20professional%20construction%20photography%20showing%20scale%20of%20underground%20project%2C%20clean%20industrial%20environment%20with%20dramatic%20lighting&width=600&height=500&seq=port-under-001&orientation=landscape',
      size: 'small'
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row gap-8 mb-16">
          <div className="lg:w-2/5">
            <p className="text-gray-500 italic text-base mb-3">Our Work</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Mega Projects Delivered
            </h2>
          </div>
          <div className="lg:w-3/5 flex items-center">
            <p className="text-lg text-gray-600 leading-relaxed">
              From towering skyscrapers to complex infrastructure systems, we've provided expert estimating, BIM modeling, and scheduling services for some of the world's most ambitious construction projects.
            </p>
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-2xl cursor-pointer ${
                project.size === 'large' ? 'md:col-span-2 md:row-span-2' : 
                project.size === 'medium' ? 'md:row-span-2' : ''
              }`}
            >
              {/* Image Container */}
              <div className={`relative w-full overflow-hidden ${
                project.size === 'large' ? 'h-96 md:h-full' : 
                project.size === 'medium' ? 'h-96 md:h-full' : 'h-80'
              }`}>
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent group-hover:from-black/90 transition-all duration-300"></div>
              </div>

              {/* Content Overlay */}
              <div className="absolute inset-0 flex flex-col justify-end p-6 lg:p-8">
                <div className="bg-orange-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full inline-block w-fit mb-3 whitespace-nowrap">
                  {project.category}
                </div>
                <h3 className="text-2xl lg:text-3xl font-bold text-white mb-2">
                  {project.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}